import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigFileUploadPathSettings } from "./app-settings-config-file-upload-path-settings";

export interface IConfigFileUploadPathInputState {
  showModal: boolean;
  editingFileUploadPathId: string;
}

export interface IConfigFileUploadPathInputProps {
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigFileUploadPathInput extends PureComponent<
  IConfigFileUploadPathInputProps,
  IConfigFileUploadPathInputState
> {
  formInputName = ["apiConfig", "fileUploadPathSettingsId"];

  constructor(props: IConfigFileUploadPathInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingFileUploadPathId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingFileUploadPathId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string) => {
    this.setState({ editingFileUploadPathId: id, showModal: true });
  };

  render() {
    const options = [...(this.props.commonSettings.fileUploadPathSettings || [])];
    return (
      <>
        <ConfigFileUploadPathSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingFileUploadPathId={this.state.editingFileUploadPathId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <div style={{ marginTop: 16 }}>
          <ConfigSettingSelect
            label="File Upload Path"
            formInputName={this.formInputName}
            options={options}
            tooltipContentKey="appsettings_connectionsettings_fileuploadpath"
            onAddNew={this.openModal}
            onEdit={this.setEditingSetting}
            dropdownTestId="appSettingsFileUploadPathDropdown"
            addNewTestId="appSettingsFileUploadPathAddNew"
            editTestId="appSettingsFileUploadPathEditButton"
          />
        </div>
      </>
    );
  }
}
